<template>
  <section class="smartsearch-serp q-bg-light q-pt-1">
    <SearchInputContainer v-if="showInput"/>
    <ResultsInfoWrapper/>
    <FiltersContainerTop v-if="(!typeQueryState && showTopFilters) || isTabletView "/>
    <div v-if="!typeQueryState" class="smartsearch-serp__container q-container-xxl q-py-lg-1 q-d-flex">
      <FiltersContainer v-if="!noResultsState && showAsideFilters || (showTopFilters && canShowFiltersOnMobile)"/>
      <ResultsContainer/>
    </div>
    <BackToTopButton v-if="useBackToTopButton"/>
  </section>

</template>

<script setup lang="ts">
import FiltersContainer from '@/components/SerpPage/FiltersContainer/FiltersContainer.vue'
import ResultsContainer from '@/components/SerpPage/ResultsContainer/ResultsContainer.vue'
import BackToTopButton from '@/components/BackToTopButton.vue'
import SearchInputContainer from '@/components/SerpPage/ResultsContainer/SearchInputContainer.vue'
import ResultsInfoWrapper from './ResultsInfoWrapper/ResultsInfoWrapper.vue'
import FiltersContainerTop from '@/components/SerpPage/FiltersContainer/FiltersContainerTop.vue'

import {onMounted, watch, inject, onUnmounted} from "vue";
import {storeToRefs} from "pinia";

import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {useSortingStore} from "@/store/SerpPage/SortingStore";
import {SmartSearchConfigInterface} from '@/core/types'
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useMobileViewStore} from "@/store/MobileViewStore";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!

const scrollPositionSessionKey = 'ss3_scroll_position'

const paginationStore = usePaginationStore()
const sortingStore = useSortingStore();
const {page} = storeToRefs(paginationStore)
const {selectedSort} = storeToRefs(sortingStore)

const serpStore = useSerpResultsStore();
const {initialised, noResultsState, typeQueryState} = storeToRefs(serpStore)

const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const {canShowFiltersOnMobile} = storeToRefs(filtersStore)
const {isTabletView} = storeToRefs(mobileViewStore)


const useBackToTopButton = SmartSearchConfig.value.serp.backToTopButton.enabled
const {showAsideFilters, showTopFilters} = SmartSearchConfig.value.serp.filters
const showInput = SmartSearchConfig.value.serp.showInput

const scrollToPosition = () => {
  const savedScrollTop = sessionStorage.getItem(scrollPositionSessionKey);
  if (savedScrollTop) {

    window.scrollTo(0, savedScrollTop);
  }
}

onMounted(async () => {
  window.addEventListener('resize', mobileViewStore.updateIsMobileView);

  await serpStore.getAndSetProducts('onMounted');
  scrollToPosition()
  initialised.value = true


  watch(selectedSort, () => {
    if (!sortingStore.shouldTriggerSelectedSortWatcher) {
      sortingStore.shouldTriggerSelectedSortWatcher = true;
      return;
    }

    serpStore.getAndSetProducts('selectedSort watcher');
  }, {immediate: false});

  watch(page, async () => {
    await serpStore.getAndSetProducts('page watcher');
  }, {immediate: false});

  window.addEventListener('popstate', () => {
    serpStore.getAndSetProducts('history event');
  });

  let lastScrollTop = 0;

  window.addEventListener('beforeunload', () => {
    lastScrollTop = window.scrollY
    sessionStorage.setItem(scrollPositionSessionKey, lastScrollTop);
  });

});


onUnmounted(() => {
  let lastScrollTop = 0;
  window.removeEventListener('beforeunload', () => {
    lastScrollTop = window.scrollY
    sessionStorage.setItem(scrollPositionSessionKey, lastScrollTop);
  });
})


</script>

<style>
#smartsearch-serp {
  font-size: 16px;
}

section.smartsearch-serp {
  min-height: 500px;
}

.q-slide-in-left {
  -webkit-animation: q-slide-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation: q-slide-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@-webkit-keyframes q-slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}




/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

/* Dodaj te style w pliku CSS komponentu lub globalnie */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active w <=2.1.8 */
{
  opacity: 0;
}

body.no-scroll {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}

#smartsearch-serp ul li {
  list-style: none !important;
}

#smartsearch-autocomplete *, #smartsearch-serp * {
  box-sizing: border-box;
}
#smartsearch-autocomplete a, #smartsearch-serp a {
  position: static!important;
}

#smartsearch-autocomplete *::-webkit-scrollbar, #smartsearch-serp *::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  border-radius: 30px;
  background-color: #e6e6e6;
}

#smartsearch-autocomplete *::-webkit-scrollbar-thumb, #smartsearch-serp *::-webkit-scrollbar-thumb {
  border-radius: 30px;
  background-color: #dc3545;
}

#smartsearch-autocomplete *::-webkit-scrollbar-track, #smartsearch-serp *::-webkit-scrollbar-track {
  border-radius: 30px;
  background-color: #e6e6e6;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}
</style>